import { Selector } from "../../components/ui";
import type { AgentCompany } from "../api/e2e";
import { formatCountry } from "../lib/companyCatalog";

export default function CompanyAutocomplete({
  companies,
  value,
  onChange,
  onClear,
  onSelect,
  selectedCompany,
  label,
  placeholder = "Search company, ticker, or country…",
  disabled = false,
}: {
  companies: readonly AgentCompany[];
  value: string;
  onChange: (value: string) => void;
  onClear?: () => void;
  onSelect: (company: AgentCompany) => void;
  selectedCompany?: AgentCompany;
  label?: string;
  placeholder?: string;
  disabled?: boolean;
}) {
  const options = companies.map((company) => ({
    value: company.id,
    label: `${company.company_name} (${company.ticker})`,
    searchText: `${company.company_name} ${company.ticker} ${formatCountry(company.country)}`,
    secondary: formatCountry(company.country),
  }));
  return (
    <Selector
      searchable
      options={options}
      value={selectedCompany?.id ?? ""}
      searchValue={value}
      onSearchChange={onChange}
      onSearchInputChange={() => {
        if (selectedCompany) onClear?.();
      }}
      onValueChange={(companyId) => {
        const company = companies.find((item) => item.id === companyId);
        if (company) onSelect(company);
      }}
      label={label}
      ariaLabel={label ?? "Company selector"}
      placeholder={placeholder}
      disabled={disabled}
      className="company-autocomplete"
    />
  );
}
